export interface IExploreState {
  tags: any[];
  tagsLoading: boolean;
  tagsError: any;
}

const defaultState = {
  tags: [],
  tagsLoading: false,
  tagsError: null,
};

export const getDefaultExploreState = () => defaultState;
